<template>
  <div class="legend-container">
    <div class="legend-item">
      <span class="color-box red-cell"></span>
      <span class="label">Toko Tutup</span>
    </div>
    <div class="legend-item">
      <span class="color-box yellow-cell"></span>
      <span class="label">Data link dan editable</span>
    </div>
    <div class="legend-item">
      <span class="color-box blue-light-cell"></span>
      <span class="label">Data tidak link dan editable</span>
    </div>
    <div class="legend-item">
      <span class="color-box red-light-cell"></span>
      <span class="label">Alert kurang dari minimum stok atau lebih dari max stok</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LegendColor'
}
</script>

<style scoped>
.legend-container {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
}

.legend-item {
  display: flex;
  align-items: center;
}

.color-box {
  width: 48px;
  height: 24px;
  display: inline-block;
  border-radius: 4px;
  margin-right: 6px;
  border: 1px solid #ccc;
}

.red-cell {
  background-color: #FF7F7F;
}

.red-light-cell {
  background-color: #FBDADE;
}

.yellow-cell {
  background-color: #ffe169;
}

.blue-light-cell {
  background-color: #bde0fe; /* Light blue */
}

.label {
  font-size: 14px;
  color: #333;
}
</style>